/*
 * Ninapenda: schede della pagina prodotto (Dettagli, Modalita' d'uso, Ingredienti, Non dimenticare).
 * I testi arrivano dai metafield in formato rich text (JSON) e qui vengono trasformati in HTML.
 * Nella versione 1.7 questo codice era in fondo a theme.js: spostato qui perche' gli
 * aggiornamenti del tema sovrascrivono theme.js.
 */
(function () {
  function textOf(node) {
    return (node.value || '').replace(/\n/g, '<br>');
  }

  function renderRichText(containerId) {
    var container = document.getElementById(containerId);
    if (!container) return;
    try {
      var json = JSON.parse(container.dataset.json);
      var html = '';
      json.children.forEach(function (block) {
        switch (block.type) {
          case 'paragraph':
            html += '<p>';
            block.children.forEach(function (child) { html += textOf(child); });
            html += '</p>';
            break;
          case 'list':
            var listTag = block.listType === 'ordered' ? 'ol' : 'ul';
            html += '<' + listTag + '>';
            block.children.forEach(function (item) {
              if (item.type === 'list-item') {
                html += '<li>';
                item.children.forEach(function (child) { html += textOf(child); });
                html += '</li>';
              }
            });
            html += '</' + listTag + '>';
            break;
          default:
            console.warn('Tipo di blocco non gestito:', block.type);
        }
      });
      container.innerHTML = html;
    } catch (e) {
      console.error('Errore nel parsing di ' + containerId, e);
    }
  }

  function renderDettagli() {
    // "Dettagli": nella 1.7 venivano mostrati solo i paragrafi
    var container = document.getElementById('richtext-dettagli');
    if (!container) return;
    try {
      var json = JSON.parse(container.dataset.json);
      var html = '';
      json.children.forEach(function (block) {
        if (block.type === 'paragraph') {
          html += '<p>';
          block.children.forEach(function (child) { html += textOf(child); });
          html += '</p>';
        }
      });
      container.innerHTML = html;
    } catch (e) {
      console.error('Error parsing richtext metafield', e);
    }
  }

  function init() {
    renderDettagli();
    renderRichText('metafield-modalita');
    renderRichText('metafield-ingredienti');
    renderRichText('metafield-non-dimenticare');
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
